import { render } from "./Paid.vue?vue&type=template&id=45c38e35&scoped=true"
import script from "./Paid.vue?vue&type=script&lang=js"
export * from "./Paid.vue?vue&type=script&lang=js"

import "./Paid.vue?vue&type=style&index=0&id=45c38e35&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c38e35"]])

export default __exports__